// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-actions-placeholder-container[data-v-82dc58c4] {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/SharedWeb/scripts/dynamic-component-editor/standard-pages/chat-room-page/ChatroomActions.vue","webpack://./ChatroomActions.vue"],"names":[],"mappings":"AAEA;EACE,aAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.message-actions-placeholder-container {\n  display: flex;\n}\n",".message-actions-placeholder-container {\n  display: flex;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
